module.exports = __webpack_public_path__ + "img/articulation.f30c6203.jpg";